import Chip from '@mui/material/Chip';

const Tag = ({ tag }) => {
  return (
    <Chip label={tag} variant="outlined" />
  )
}

export default Tag;
